// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"7774aa2f","187":"8ecbc475","652":"4da34fba","917":"e65b4ce5"}[chunkId] + ".chunk.js";
};